export const toolbarConfig = [
  {
    name: 'reset',
    type: 'normal',
    label: '重做',
    tooltip: '清除所有设置',
    icon: 'reset.png',
    needSelection: false,
    needFocus: false
  },
  {
    name: 'sep1',
    type: 'separator'
  },
  // {
  //   name: 'multiWord',
  //   type: 'plugin',
  //   label: '多音字',
  //   tooltip: '点击纠正多音字读音',
  //   icon: 'multi.png',
  //   needSelection: true,
  //   needFocus: true
  // },
  {
    name: 'digits',
    type: 'plugin',
    label: '数字',
    tooltip: '选中数字文本后选择读法',
    icon: 'number.png',
    needSelection: true,
    needFocus: true
  },
  // {
  //   name: 'recycle',
  //   type: 'plugin', // 普通工具类型
  //   icon: 'recycle.png',
  //   label: '连续',
  //   tooltip: '点击后当前光标前后两字连读',
  //   needSelection: false,
  //   needFocus: true
  // },
  {
    name: 'pause',
    type: 'dropdown',
    label: '停顿',
    tooltip: '点击后当前光标插入停顿',
    icon: 'pause.png',
    needSelection: false,
    needFocus: true,
    options: [
      { 
        id: 'pause-weak',
        label: '0.2s', 
        value: {
          time: '200ms'
        }
      },
      { 
        id: 'pause-medium',
        label: '0.5s', 
        value: {
          time: '500ms'
        }
      },
      { 
        id: 'pause-strong',
        label: '1s', 
        value: {
          time: '1000ms'
        }
      }
    ]
  },
  {
    name: 'speed',
    type: 'popover',  // 新增类型
    label: '局部变速',
    tooltip: '选中文本，点击调节局部语速',
    icon: 'speed.png',
    needSelection: true,
    needFocus: true,
    options: {
      min: 50,
      max: 200,
      step: 10,
      default: 100
    }
  },
  // {
  //   name: 'tone',
  //   icon: 'tone.png',
  //   label: '局部变调',
  //   tooltip: '选中文本，点击调节局部语调',
  //   needSelection: true,
  //   needFocus: true
  // },
  {
    name: 'voice',
    icon: 'people.png',
    label: '多人配音',
    tooltip: '选中文本，点击选中指定主持人',
    needSelection: true,
    needFocus: true
  },
  // {
  //   name: 'music',
  //   icon: 'background.png',
  //   label: '背景音乐',
  //   tooltip: '点击添加全局背景音乐'
  // }
]